import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const getters = {
    getTypeActorFields() {
        return {
            model: 'type_actor',
            label: 'Types Actor',
            fields: [
                { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
                { key: 'id_license', label: 'id_license', type: 'number', sortable: true, required: true },
                { key: 'status', label: 'status', type: 'boolean', sortable: true, required: true },
            ]
        }
    },
}

export const actions = {
    async fetchInventories(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/inventory/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchInventoriesTransfer(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/inventory/transfer${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchInventoriesEntry(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/inventory/entry${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchInventoriesSale(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/inventory/sale${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchReportPaymentEntry(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/inventory/purchase_totals_by_payment_method${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchReportProductEntry(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/inventory/purchase_totals_by_product${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchReportPaymentSale(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/inventory/sale_totals_by_payment_method${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchReportProductSale(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/inventory/sale_totals_by_product${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchReportPaymentConsolidate(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/inventory/difference_purchase_sale_by_payment_method${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchReportProductConsolidate(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/inventory/difference_purchase_sale_by_product${query}`)
            .then((response) => {
                return response.data;
            })
    },
    
    async fetchOptionsInventories(context, query = '') {
        return axios
            .options(`${serverUrl}/api/v1/inventory/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async createInventories(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/inventory/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async updateInventories(context, payload) {
        return axios
            .put(`${serverUrl}/api/v1/inventory/${payload.id}/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async deleteInventories(context, id) {
        return axios
            .delete(`${serverUrl}/api/v1/inventory/${id}/`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchSalesExcel(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/inventory/sale_excel${query}`, {
                responseType: 'blob'
            })
    },

    async getInventory(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/inventory/current_inventory${query}`)
            .then((response) => {
                return response.data;
            })
    },
}